import { SxProps, Theme } from '@mui/material';
import { ReactNode } from 'react';
import { FormLabel } from 'src/components/Forms/FormLabel/form-label';
import { SidePanelRow } from 'src/components/SidePanelRow';

const PILL_ROW_GAP = 0.75;

interface PillRowProps {
  label: string;
  children: ReactNode;
  sx?: SxProps<Theme>;
}

/**
 * One wrapping line for a side-panel property whose value is a list of pills: the
 * label is just the first item, so pills start beside it and overflow wraps beneath it.
 */
export const PillRow = ({ label, children, sx }: PillRowProps) => (
  <SidePanelRow flexWrap="wrap" gap={PILL_ROW_GAP} rowGap={1} sx={sx}>
    <FormLabel label={label} />
    {children}
  </SidePanelRow>
);
